import { defineStore } from "pinia";
import { usePlatformApi } from "@k-digitale/kappa";
import { CesfNotification } from "@/services/cesf/models";
import { multichannelNotificationService } from "@/modules/multichannelNotifications/service";

const { execApiCall } = usePlatformApi();
export interface MultichannelNotificationState {
  // TODO
  loadingNotification: boolean,
  loadingNotifications: boolean,
  notifications: CesfNotification[],
}

export const useMultichannelNotificationsStore = defineStore('kappa-multichannel-notifications-store', {
  state: () => ({
    loadingNotification: false,
    loadingNotifications: false,
    notifications: []
  } as MultichannelNotificationState),

  getters: {
      //
  },

  actions: {
    async getUserNotifications(pageIndex : number, pageSize : number) {
      this.loadingNotifications = true;
      const response = await multichannelNotificationService.getUserUnseenNotifications(pageIndex, pageSize);
      if(response.items){
          this.notifications = response.items;
      }

      this.loadingNotifications = true;
    },

    async setNotificationSeen (id : number){
      this.loadingNotification = true;
      const response = await multichannelNotificationService.setNotificationSeen(id);
      this.loadingNotification = true;
    }

  }
})